export default function Cancel() {
	document.title = 'Payment canceled - Extractor';

	return (
		<div style={{ textAlign: 'center' }}>
			Your payment was canceled. If you need assistance please contact us at support@extractor.me
		</div>
	);
}
